import React, { useState, useEffect } from "react";
import "./Pokemon.css";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  CardActions,
  Button,
} from "@material-ui/core";
import Axios from "axios";
import { Link } from "react-router-dom";
import Loader from "./Loader/Loader";

const MyPoke = ({ obj, id, height, weight, Ability, Type1, Type2 }) => {
  // console.log(obj, "Object", id, "ID");
  return (
    <>
      <Grid item md={6} sm={8} xs={11}>
        <Card raised style={{ margin: "5vh 0 5vh 0" }}>
          <Typography
            variant="h6"
            color="secondary"
            component="span"
            style={{
              position: "absolute",
              fontWeight: "bold",
              margin: "1.2vw 0 0 3vw",
            }}
          >
            ({id})
          </Typography>
          <CardActionArea>
            <Typography
              align="center"
              variant="h5"
              color="secondary"
              style={{
                textTransform: "uppercase",
                textAlign: "center",
                marginTop: "3vh",
              }}
            >
              {obj.name}
            </Typography>
            <CardMedia
              component="img"
              height="520"
              image={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`}
              style={{ textDecoration: "none" }}
            ></CardMedia>
            <CardContent>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  marginTop: "5vh",
                }}
              >
                <Typography
                  align="center"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.02em",
                    marginTop: "-8vh",
                  }}
                >
                  <Typography className="Poke__Single--Heading" variant="h6">
                    Height
                  </Typography>
                  <Typography
                    className="poke__Single--data"
                    variant="p"
                    component="p"
                    style={{ textTransform: "capitalize" }}
                  >
                    {height / 10} {"m"}
                  </Typography>
                </Typography>
                <Typography
                  align="center"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.02em",
                    marginTop: "-8vh",
                  }}
                >
                  <Typography className="Poke__Single--Heading" variant="h6">
                    Weight
                  </Typography>
                  <Typography
                    className="poke__Single--data"
                    variant="p"
                    component="p"
                    style={{ textTransform: "capitalize" }}
                  >
                    {weight / 10} {"kg"}
                  </Typography>
                </Typography>
                {/* </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  marginTop: "5vh",
                }}
              > */}
                <Typography
                  align="center"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.02em",
                    marginTop: "-8vh",
                  }}
                >
                  <Typography className="Poke__Single--Heading" variant="h6">
                    Ability
                  </Typography>{" "}
                  <Typography
                    className="poke__Single--data"
                    variant="p"
                    component="p"
                    style={{ textTransform: "capitalize" }}
                  >
                    {Ability}
                  </Typography>
                </Typography>
                <Typography
                  align="center"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.02em",
                    marginTop: "-8vh",
                  }}
                >
                  <Typography className="Poke__Single--Heading" variant="h6">
                    Type
                  </Typography>
                  <Typography
                    className="poke__Single--data"
                    variant="p"
                    component="p"
                    style={{ textTransform: "capitalize" }}
                  >
                    {Type1}
                    {/* {Type2} */}
                  </Typography>
                </Typography>
              </div>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Button variant="contained" fullWidth color="secondary">
                Back
              </Button>
            </Link>
            <Button color="secondary" style={{ marginLeft: "auto" }}>
              I ❤ PokeMon
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  );
};

function Pokemon(props) {
  const id = props.match.params.id;

  const [Poke, setPoke] = useState([]);
  const [LoadPok, setLoadPok] = useState(false);

  const [Height, setHeight] = useState("");
  const [Weight, setWeight] = useState("");

  const [Ability, setAbility] = useState("");
  const [Type1, setType1] = useState("");
  // const [Type2, setType2] = useState("");

  useEffect(() => {
    const PokeDataFunc = async () => {
      const PokeApiCallData = await Axios.get(
        `https://pokeapi.co/api/v2/pokemon/${id}`
      );

      // console.log(PokeApiCallData, "what");

      const { data } = PokeApiCallData;

      // console.log(data.abilities[0].ability.name, "Ability");
      // console.log(data.types[0].type.name, "type");
      // console.log(data.abilities[1].ability.name, "Type");

      // console.log(Ability, Type1, Type2, "Other Data Type");
      const { height, weight } = data;

      setHeight(height);
      setWeight(weight);
      setPoke(data.forms);
      setAbility(data.abilities[0].ability.name);
      setType1(data.types[0].type.name);
      // setType2(data.abilities[1].ability.name);
      setLoadPok(true);
    };
    PokeDataFunc();
  }, []);

  return (
    <>
      {/* <Typography
        className="My__Name"
        component="h6"
        variant="h6"
        color="secondary"
        style={{ position: "absolute", right: "10vw", top: "1vh" }}
      >
        Ali Adnan Asim
      </Typography> */}
      <Grid
        className="Poke__Single"
        container
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!LoadPok ? (
          <Loader />
        ) : (
          Poke.map((obj, index) => {
            return (
              <MyPoke
                obj={obj}
                height={Height}
                weight={Weight}
                key={index}
                id={id}
                Ability={Ability}
                Type1={Type1}
                // Type2={Type2}
              />
            );
          })
        )}
      </Grid>
    </>
  );
}

export default Pokemon;
